import React from 'react';
import ChooseIdComponent from '../components/chooseid';

const ChooseId = () => {
  return <ChooseIdComponent />;
};

export default ChooseId;
